import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const WooImportPage = lazy(() =>
	import('./components/WooImportPage').then((module) => ({
		default: module.WooImportPage
	}))
);

/**
 * Admin-only WooCommerce import (spec docs/superpowers/specs/2026-09-30-woocommerce-import-design.md §5).
 * The API enforces Admin too, and checks the admin can access the chosen location.
 */
const wooCommerceImportRoutes: FuseRouteItemType[] = [
	{
		path: 'woocommerce-import',
		auth: ['Admin'],
		element: <WooImportPage />
	}
];

export default wooCommerceImportRoutes;
